<script>
import axios from 'axios'

export const apiBaseUrl = process.env.VUE_API_BASE_URL || ''
export const apiLogin = apiBaseUrl + 'user/login'
export const apiAcl = apiBaseUrl + 'user/acl'
export const apiSupplierLookup = apiBaseUrl + 'supplier/lookup'
export const apiPoSearch = apiBaseUrl + 'po/search'
export const apiWarehouseLookup = apiBaseUrl + 'warehouse/lookup'
export const apiProductLookup = apiBaseUrl + 'product/lookup'
export const apiPOSave = apiBaseUrl + 'po/save'
export const apiPoGet = apiBaseUrl + 'po/get'
export const apiPOApprove = apiBaseUrl + 'po/approve'
export const apiPOLookup = apiBaseUrl + 'po/lookup'
export const apiGRNSave = apiBaseUrl + 'grn/save'
export const apiGROSave = apiBaseUrl + 'gro/save'
export const apiLocationProductUrl = apiBaseUrl + 'product/location/lookup'
export const apiGroSearch = apiBaseUrl + 'gro/search'
export const apiGroGet = apiBaseUrl + 'gro/get'
export const apiCountryLookup = apiBaseUrl + 'country/lookup'
export const apiStockcard = apiBaseUrl + 'inventory/stockcards'
export const apiWtoSave = apiBaseUrl + 'wto/save'
export const apiWtoSearch = apiBaseUrl + 'wto/search'
export const apiWtoGet = apiBaseUrl + 'wto/get'
export const apiWtoLookup = apiBaseUrl + 'wto/lookup'
export const apiWtoManualClose = apiBaseUrl + 'wto/manualclose'
export const apiWtrSearch = apiBaseUrl + 'wtr/search'
export const apiWtrSave = apiBaseUrl + 'wtr/save'
export const apiPodSearch = apiBaseUrl + 'pod/search'
export const apiSanSave = apiBaseUrl + 'san/save'
export const apiSanSearch = apiBaseUrl + 'san/search'
export const apiSrfSearch = apiBaseUrl + 'srf/search'
export const apiSrfGet = apiBaseUrl + 'srf/get'
export const apiSrfLookup = apiBaseUrl + 'srf/lookup'
export const apiSrfSave = apiBaseUrl + 'srf/save'
export const apiSrfClose = apiBaseUrl + 'srf/close'
export const apiSrfApprove = apiBaseUrl + 'srf/approve'
export const apiSrrSearch = apiBaseUrl + 'srr/search'
export const apiSrrSave = apiBaseUrl + 'srr/save'
export const apiEmployeeLookup = apiBaseUrl + 'employee/lookup'
export const apiPOManualClose = apiBaseUrl + 'po/manualclose'
export const apiSbrSearch = apiBaseUrl + 'sbr/search'
export const apiWscSearch = apiBaseUrl + 'wsc/search'
export const apiWscSave = apiBaseUrl + 'wsc/save'
export const apiSanClose = apiBaseUrl + 'san/close'
export const apiSanApprove = apiBaseUrl + 'san/approve'
export const apiSanGet = apiBaseUrl + 'san/get'
export const apiWsiSearch = apiBaseUrl + 'wsi/search'
export const apiGeneratePickingList = apiBaseUrl + 'wsi/picklist/generate'
export const apiMemberLookup = apiBaseUrl + 'member/lookup'
export const apiPicklistGet = apiBaseUrl + 'wsi/picklist/get'
export const apiGenerateDO = apiBaseUrl + 'wsi/packlist/generatedo'
export const apiPodUpdate = apiBaseUrl + 'pod/update'
export const apiWscLookUp = apiBaseUrl + 'wsc/lookup'
export const apiGriSearch = apiBaseUrl + 'gri/search'
export const apiGriGet = apiBaseUrl + 'gri/get'
export const apiGriSave = apiBaseUrl + 'gri/save'
export const apiBackOrdersSearch = apiBaseUrl + 'report/backorder'
export const apiDeliveredOrdersSearch = apiBaseUrl + 'report/deliveredproducts'
export const apiOutstandingOrdersSearch = apiBaseUrl + 'report/outstandingorders'
export const apiCourierLists = apiBaseUrl + 'courier/retrieve'
export const apiPoGrnTrackingReport = apiBaseUrl + 'report/po_grn_tracking'
export const apiSrfDoListingReport = apiBaseUrl + 'report/srf_do_listing'
export const apiSrUsageListingReport = apiBaseUrl + 'report/sr_usage_listing'
export const apiGriDetailsSearch = apiBaseUrl + 'gri/details_search'
export const apiReasonLookup = apiBaseUrl + 'reason/lookup'

export function authUser (userName, userPassword) {
  // eslint-disable-next-line no-unused-expressions
  localStorage.clear
  try {
    axios.post(apiLogin, {
      userId: userName,
      password: userPassword
    })
  } catch (e) {
    this.errors.push(e)
  }
}
export function authACL (functionName) {
  if (!localStorage.access_token) {
    return 0
  } else {
    axios.post('/user/acl', {
      accessToken: localStorage.access_token,
      function: functionName
    })
      .then(res => {
        console.log('Check Auth ACL')
        console.log(res)
        localStorage.setItem('auth_code', res.data.code)
      })
      .catch(error => (alert(error))
      )
  }
}
export const authHeader = function () {
  const accessToken = localStorage.access_token
  return {
    'headers':
        {
          'Accept': 'application/json',
          'Authorization': 'Bearer ' + accessToken
        }
  }
}
</script>



// WEBPACK FOOTER //
// src/functions/common.vue